import { render, staticRenderFns } from "./protocolAuthorization.vue?vue&type=template&id=29909ede&scoped=true"
import script from "./protocolAuthorization.vue?vue&type=script&lang=js"
export * from "./protocolAuthorization.vue?vue&type=script&lang=js"
import style0 from "./protocolAuthorization.vue?vue&type=style&index=0&id=29909ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29909ede",
  null
  
)

export default component.exports